/**
 * billing — constantes de assinatura/pagamento (item D).
 *
 * Portal de pagamento = clientes.ondiet.app (Stripe Customer Portal). É o mesmo
 * destino do "Gerenciar minha conta" do Profile; lá o usuário atualiza cartão /
 * paga a fatura em atraso.
 */
export const BILLING_PORTAL_URL = "https://clientes.ondiet.app/login";

/**
 * Onde os planos moram — FORA do app, de propósito.
 *
 * ⚠️ **Nenhum preço e nenhum nome de plano pode aparecer dentro do app.** Este é
 * o mesmo motivo da decisão T5 (`/signup` → funil, sem redirecionar a webview do
 * Median): catálogo e valor dentro do app são o que a política de compra da
 * Apple alcança, e pagar a comissão comeria a margem. O padrão do app é CTA
 * neutro + `openExternal`, exatamente como o `SubscriptionBlockScreen` já faz
 * com o `BILLING_PORTAL_URL` acima.
 *
 * Há teste que falha se preço ou nome de plano voltar pra tela de assinatura
 * encerrada — a proteção não pode depender de alguém lembrar.
 *
 * 📌 **Aponta para o PORTAL, não para o site.** Quem chega nesta tela já é
 * cliente; `ondiet.app/pricing` é a página de vendas pública e o trataria como
 * visitante que nunca ouviu falar do app. `clientes.ondiet.app/planos` é a área
 * do cliente, com a copy de quem está voltando ([portal#5]).
 *
 * A rota de lá é **pública** de propósito — o `/` do portal continua protegido.
 * Cobrar login com Turnstile de alguém que acabou de cancelar derruba a
 * reativação, e preço já é informação pública.
 *
 * ⚠️ Não trocar por `billing.stripe.com`: medido na conta em 2026-08-11, o
 * Customer Portal está com `subscription_update: false` e só sabe **cancelar** —
 * para assinatura já encerrada não tem o que oferecer.
 */
export const PLANOS_URL = "https://clientes.ondiet.app/planos";
